import React, { Suspense } from "react";
import dayjs from "dayjs";

import styles from "./AscVoiceRecorder.module.scss";

const LiveAudioVisualizer = React.lazy(async () => {
  const { LiveAudioVisualizer } = await import("react-audio-visualize");
  return { default: LiveAudioVisualizer };
});

export type recorderControls = {
  startRecording: () => void;
  stopRecording: () => void;
  togglePauseResume: () => void;
  recordingBlob?: Blob;
  isRecording: boolean;
  isPaused: boolean;
  recordingTime: number;
  mediaRecorder?: MediaRecorder;
};

export function AscAudioRecorderVisualizer({
  controller,
}: {
  controller: recorderControls;
}) {
  return (
    <div className={styles.audioVizualizer}>
      {controller.mediaRecorder ? (
        <Suspense fallback={<></>}>
          <LiveAudioVisualizer
            mediaRecorder={controller.mediaRecorder}
            gap={4}
            width={400}
            height={48}
            smoothingTimeConstant={0.8}
            barColor="#4239FB"
            backgroundColor="#dad8ff"
          />
        </Suspense>
      ) : (
        <div className={styles.audioVizualizerCustom}>
          <hr className={styles.audioVizualizerCustomDash} />
        </div>
      )}
      <span className={styles.audioLength}>
        {dayjs
          .duration(controller.recordingTime || 0, "seconds")
          .format("mm:ss")}
      </span>
    </div>
  );
}
